import { Text } from "@mantine/core";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";

// Сохранённое значение шаблона моноширинным текстом. Пустая строка может
// быть сохранённым невалидным значением; без метки она выглядела бы как
// отсутствие значения, поэтому подменяется явной подписью.
export function StoredTemplateText({
  value,
}: {
  readonly value: string;
}): ReactElement {
  const { t } = useTranslation();
  if (value === "") {
    return (
      <Text size="sm" c="dimmed" fs="italic">
        {t("branchNameTemplate.emptyStored")}
      </Text>
    );
  }
  return (
    <Text size="sm" ff="monospace">
      {value}
    </Text>
  );
}
